import React from 'react'
import { mount } from '../utils/mount'
import { PageRoot } from '../components/page-root'
import { ProductHerbPeelCleansingGelPage } from '../pages/product-herb-peel-cleansing-gel-page'

mount('#skn-remed-product-page', <PageRoot><ProductHerbPeelCleansingGelPage /></PageRoot>)
